<template>
    <div>
      <Header :color="colorHeader" :image="image" :key="showLoading"/>
      <div v-if="showLoading" class="loading" :key="showLoading">
        <b-container>
          <b-row class="full-heigth">
            <b-col class="align-self-center">
              <span class="loader"></span>
              <h1>CALCULANDO TU <br> CAPACIDAD DE CRÉDITO</h1>
              <p>ESTAMOS REVISANDO TUS DATOS</p>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div v-else class="message align-self-center">
        <b-container>
          <b-row class="full-heigth-header">
            <b-col class="align-self-center">
              <div class="message-container">
                <b-row v-if="this.applicant_country=='Estados Unidos'">
                  <b-col lg="12" class="align-self-center nodocument-col">
                    <div class="txt-header">
                        <span>ESTAMOS TRABAJANDO <span class="text-gold">EN CALCULAR TU</span></span> <br>
                        <span style="white-space: nowrap;" class="black-bg">TU CAPACIDAD DE CRÉDITO</span>
                    </div>
                    <p class="mb-4 mt-4 address">Personal de Garlan's se estará comunicando <br> contigo dentro de las proximas 48 hrs.<br><br>También puedes contactarnos si tienes<br> dudas acerca de tu solicitud<br><span>235 East Second Street Calexico CA 92231<br> (760) 357 6846 Departamento de Crédito <br>Lunes a Sábado de 10 a.m. a 7 p.m. <br>Domingos de 10 a.m. a 6 p.m.</span></p>
                    <h2 class="mb-5">¡Gracias!</h2>
                    <a href="https://www.garlans.com/">Ir a tienda</a>
                  </b-col>
                </b-row>
                <b-row v-if="amount && documents!=3 && this.applicant_country!='Estados Unidos'">
                  <b-col lg="12" class="align-self-center nodocument-col">
                    <div class="txt-header">
                        <span>EN ESTE MOMENTO <span class="text-gold">NO PUDIMOS CALCULAR</span></span> <br>
                        <span style="white-space: nowrap;" class="black-bg">TU CAPACIDAD DE CRÉDITO,</span><span> REVISA TU <br> CORREO PARA CONTINUAR CON TU SOLICITUD.</span>
                    </div>
                    <p class="mb-4 mt-4 address">Ponte en contacto con uno de nuestros <br> ejecutivos Garlan's para revisar tu caso.<br><br><span>235 East Second Street Calexico CA 92231<br> (760) 357 6846 Departamento de Crédito <br>Lunes a Sábado de 10 a.m. a 7 p.m. <br>Domingos de 10 a.m. a 6 p.m.</span></p>
                    <h2 class="mb-5">¡Gracias!</h2>
                    <a href="https://www.garlans.com/">Ir a tienda</a>
                  </b-col>
                </b-row>
                <b-row v-if="amount && documents==3 && this.applicant_country!='Estados Unidos'">
                  <b-col lg="6" class="align-self-center">
                    <div class="txt-header">
                        <span>TU <span class="text-gold">CRÉDITO APROXIMADO</span></span><br>
                        <span class="black-bg">PRE-APROBADO</span>
                    </div>
                    <h1 class="amount mb-4 mt-4">$ {{Number(amount).toLocaleString('es-MX')}} DLLS</h1>
                    <p class="mb-5">Esta cantidad es un estimado de tu cálculo de crédito. Personal de Garlan's se estará comunicando contigo dentro de las próximas 48 hrs.</p>
                    <a href="https://www.garlans.com/">Ir a tienda</a>
                  </b-col>
                  <b-col lg="6" class="girl-container">
                    <img class="img-girl" src="../assets/img/img_girl.png" alt="Stock image" title="Stock image">
                  </b-col>
                </b-row>
                <b-row  v-if="amount==0">
                  <b-col lg="12" class="align-self-center noapproved-col">
                    <div class="txt-header">
                        <span>NO <span class="text-gold">PUDIMOS CALCULAR</span> TU</span> <br>
                        <span style="white-space: nowrap;" class="black-bg">CAPACIDAD DE CRÉDITO </span>
                    </div>
                    <p class="mt-3">Ponte en contacto con uno de nuestros ejecutivos Garlan’s para revisar tu caso.</p>
                    <p class="mb-5 mt-3 address"><span>235 East Second Street Calexico CA 92231 <br>(760) 357 6846 Departamento de Crédito <br>Lunes a Sábado de 10 a.m. a 7 p.m. <br>Domingos de 10 a.m. a 6 p.m.</span></p>
                    <a href="https://www.garlans.com/">Ir a tienda</a>
                  </b-col>
                </b-row>
              </div>
              </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
</template>

<script>
    import Header from '../components/Header.vue'
    export default {
      created() {
        if(this.documents!=3 || this.applicant_country=='Estados Unidos'){
          this.colorHeader = '',
          this.image =  require('../assets/img/img-logo.png')
          this.showLoading = false
        }
        setTimeout(() => {
            this.colorHeader = '',
            this.image =  require('../assets/img/img-logo.png')
            this.showLoading = false
        }, 5000)
      },
      data() {
            return {
              showLoading: true,
              colorHeader: 'light',
              image: require('../assets/img/img_logo_white.png'),
            }
      },
      components: {
        Header
      },
      props: { 
          amount: {
              type: Number,
              default: 0,
              required: false
          },
          documents: {
              type: Number,
              default: 0,
              required: false
          },
          applicant_country: {
              type: String,
              default: 'México',
              required: false
          }
      },
    }
</script>

<style scoped>
.message{
  padding: 2% 5%;
  max-height: 90vh;
}
.message-container{
  background-image: url('../assets/img/img_confirmation_bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.message-container p{
  color: #fff;
  text-align: center;
  max-width: 350px;
  margin: auto;
}
.message-container p.address{
  max-width: 560px;
}
.message-container p.address span{
  font-size: 13px;
}
.message-container a{
  background: #000;
  color: #fff;
  font-weight: bold;
  text-decoration: none;
  padding: 7px 50px;
}
h2{
  color: #fff;
  font-weight: bold;
  font-size: 35px;
}
.amount{
  color: #F7D85C;
  font-weight: bold;
  font-size: 3rem;
}
.img-girl{
  width: 100%;
}
.loading{
    min-height: 100vh;
    min-width: 100vw;
    background-image: url('../assets/img/img_bg.jpg');
    background-size: cover;
}
.loading h1{
    color: #fff;
    font-weight: bold;
    font-size: 50px;
    margin-top: 30px;
}
.loading p{
    color: #fff;
}
.full-heigth{
  min-height: 100vh;
}
.full-heigth-header{
  min-height: calc(100vh - 62px);
}
.noapproved-col{
  padding: 12% 0;
}
.nodocument-col{
  padding: 10% 0;
}
.txt-header{
    font-family: futura-pt, sans-serif;
    font-weight: 600;
    font-style: normal;
    color: #fff;
    text-align: center;
    font-size: 40px;
    line-height: 1.2;
}
.text-gold{
    color:#F7D85C;
}
.black-bg{
    background: #000;
    padding: 0 5px;
}

.loader {
  transform: translateZ(1px);
}
.loader:after {
  content: '$';
  display: inline-block;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  text-align: center;
  line-height:90px;
  font-size: 70px;
  font-weight: bold;
  background: #FFD700;
  color: #DAA520;
  border: 4px double ;
  box-sizing: border-box;
  box-shadow:  2px 2px 2px 1px rgba(0, 0, 0, .1);
  animation: coin-flip 8s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
@keyframes coin-flip {
  0%, 100% {
    animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
  }
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(1800deg);
    animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
  }
  100% {
    transform: rotateY(3600deg);
  }
}

@media (max-width: 1600px) {
  .noapproved-col{
    padding: 15% 0;
  }
  .nodocument-col{
    padding: 12% 0;
  }
  .loading h1{
      font-size: 38px;
  }
  .loader:after {
    width: 80px;
    height: 80px;
    line-height:72px;
    font-size: 55px;
  }
  .img-girl{
    width: 100%;
  }
  .message{
    padding: 0 10%;
  }
  .txt-header{
    font-size: 32px;
  }
  .message-container p{
    font-size: 16px;
  }
  .amount{
    font-size: 2.7rem;
  }
}

@media (max-width: 768px) {
  .loading h1{
      font-size: 25px;
      margin-top: 20px;
  }
  .loading p{
      font-size: 14px;
  }
  .loader:after {
    width: 60px;
    height: 60px;
    line-height:52px;
    font-size: 40px;
  }
  .girl-container{
    display: none;
  }
  .message{
    padding: 0;
  }
  .message-container{
    padding: 20% 10%;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 30px;
  }
  .txt-header{
    font-size: 23px;
  }
  .message-container p{
    font-size: 14px;
  }
  .amount{
    font-size: 2.5rem;
  }
  .message-container a{
    font-size: 13px;
  }
  .noapproved-col{
    padding: 0 3%;
  }
  .nodocument-col{
    padding: 0 3%;
  }
  
}
@media (max-width: 340px) {
  .black-bg{
    white-space: normal !important;
  }
}

</style>